import { render } from "./DrugstoreListDesktop.vue?vue&type=template&id=49b5cf7f&scoped=true&lang=pug"
import script from "./DrugstoreListDesktop.vue?vue&type=script&lang=js"
export * from "./DrugstoreListDesktop.vue?vue&type=script&lang=js"

import "./DrugstoreListDesktop.vue?vue&type=style&index=0&id=49b5cf7f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b5cf7f"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QImg,QExpansionItem,QSlideTransition,QItem});
